<template>
  <article
    :id="`icon-${iconFamily}-${icon.name}-${iconStyle}`"
    class="wrap-icon with-top-tag"
  >
    <button
      class="icon flat"
      :style="`${buttonResultsStyle} ${buttonIsSelectedStyle}
        width: 100%;
        height: 100%;
        --button-font-weight: var(--font-weight-normal);
        --button-margin-bottom: 0`"
      @click="$emit('toggleIcon', icon, `icon-${iconFamily}-${icon.name}-${iconStyle}`, icon.objectID)"
    >
      <span>
        <i :class="`${translatedStyle} fa-${icon.name} fa-fw`" />
      </span>
      <span class="icon-name">{{ icon.name }}</span>
    </button>

    <wa-tag
      v-if="showNewTag"
      :position="proTagPosition"
      :position-indent="proTagPositionIndent"
      :size="proTagSize"
      background="var(--fa-teal)"
      color="var(--fa-navy)"
      label="New"
    />

    <wa-tag
      v-if="showProTag"
      :position="proTagPosition"
      :position-indent="proTagPositionIndent"
      :size="proTagSize"
      background="var(--fa-yellow)"
      color="var(--fa-navy)"
      explanation="Using this requires Font Awesome Pro"
      label="Pro"
    />
  </article>
</template>

<script>
  import { getLongCode } from 'app/releases.js'

  export default {
    name: 'Icon',

    props: {
      buttonHoverColor: {
        type: String,
        default: 'var(--fa-yellow)'
      },
      icon: {
        type: Object
      },
      isProUser: {
        type: Boolean
      },
      isPromotional: {
        type: Boolean,
        default: false
      },
      resultsView: {
        type: String
      },
      scrollTo: {
        type: Boolean,
        required: false
      },
      selectedIconId: {
        type: String
      },
      selectedFamily: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      newTagEnabled: {
        type: Boolean,
        default: false
      },
      version: {
        type: Number,
        default: null
      }
    },

    computed: {
      buttonResultsStyle() {
        if (this.resultsView == 'cheatsheet') {
          return '--button-padding: var(--spacing-sm);'
        } else {
          return '--button-padding: var(--spacing-xl) var(--spacing-sm) var(--spacing-md) var(--spacing-sm);'
        }
      },

      buttonIsSelectedStyle() {
        if (this.isSelected) {
          return '--button-background: var(--fa-navy); --button-color: var(--white); --button-hover-background: var(--fa-dk-navy); --button-hover-color: var(--white);'
        } else {
          return `--button-background: var(--white); --button-hover-background: ${this.buttonHoverColor}; --button-color: var(--fa-navy); --button-hover-color: var(--fa-navy);`
        }
      },

      translatedStyle() {
        if (this.version === 5) {
          switch (this.iconFamily) {
            case 'brands':
              return 'fab'

            default:
              return `fa${this.iconStyle.charAt(0)}`
          }
        } else {
          return getLongCode(this.iconFamily, this.iconStyle)
        }
      },

      iconFamily() {
        return this.icon.family
      },

      iconStyle() {
        return this.icon.style
      },

      isSelected() {
        return this.selectedIconId == this.icon.name && this.selectedFamily == this.iconFamily && this.selectedStyle == this.iconStyle
      },

      proTagPosition() {
        return this.resultsView == 'cheatsheet' ? 'top right' : ''
      },

      proTagPositionIndent() {
        return this.resultsView == 'cheatsheet' ? 'var(--spacing-lg)' : ''
      },

      proTagSize() {
        return this.resultsView == 'cheatsheet' ? 'size-2xs' : ''
      },

      showTag() {
        return !this.isPromotional
      },

      showNewTag() {
        return this.showTag && this.newTagEnabled && !this.showProTag && this.icon.is_new_in_v6
      },

      showProTag() {
        return this.showTag && !this.icon.is_free && !this.isProUser
      }
    },

    mounted() {
      if (this.scrollTo) {
        this.$el.scrollIntoView(false)
      }
    }
  }
</script>
